import { LayoutDashboard, QrCode, Send, ReceiptText, Users, Banknote, ListOrdered } from "lucide-react";

export const USER_NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/dashboard/qr", label: "Static QR", icon: QrCode, testid: "nav-static-qr" },
  { to: "/dashboard/payouts", label: "Payouts", icon: Send, testid: "nav-payouts" },
  { to: "/dashboard/transactions", label: "Transactions", icon: ReceiptText, testid: "nav-transactions" },
];

export const ADMIN_NAV = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, testid: "nav-admin-overview" },
  { to: "/admin/users", label: "Users", icon: Users, testid: "nav-admin-users" },
  { to: "/admin/payouts", label: "Payout Requests", icon: Banknote, testid: "nav-admin-payouts" },
  { to: "/admin/transactions", label: "Transactions", icon: ListOrdered, testid: "nav-admin-transactions" },
];
